import { datadogRum } from '@datadog/browser-rum';

export default function datadogInit() {
    if (import.meta.env.CLIENT_ENVIRONMENT !== 'local') {
      datadogRum.init({
        applicationId: '262244ab-4202-4bec-a892-1b6f693e5f5b',
        clientToken: 'pub25826807cab10be4d1eedc912808a3c9',
        site: 'us3.datadoghq.com',
        service: 'da-landpride-client',
        env: import.meta.env.CLIENT_ENVIRONMENT,
        version: __APP_VERSION__, // dynamically replaced by vite at build time.
        sessionSampleRate: 100,
        sessionReplaySampleRate: 0,
        trackBfcacheViews: true,
        defaultPrivacyLevel: 'mask-user-input',
      });
    }
}